import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import type { SmsTemplate } from "@/types/sms-queue";
import { previewSmsMessage } from "@/utils/smsUtils";

interface SmsTemplatePreviewProps {
  template: SmsTemplate;
  onClose: () => void;
}

export const SmsTemplatePreview = ({ template, onClose }: SmsTemplatePreviewProps) => {
  const previewText = previewSmsMessage(template.message);
  
  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <div>
          <h4 className="font-medium mb-2">Template Original:</h4>
          <div className="p-3 bg-muted rounded-md">
            <p className="text-sm">{template.message}</p>
          </div>
        </div>
        
        <div>
          <h4 className="font-medium mb-2">Preview com dados de exemplo:</h4>
          <div className="p-3 bg-background border rounded-md">
            <p className="text-sm">{previewText}</p>
            <p className="text-xs text-muted-foreground mt-2">
              {previewText.length}/160 caracteres
            </p>
          </div>
        </div>
        
        <div>
          <h4 className="font-medium mb-2">Variáveis utilizadas:</h4>
          <div className="flex flex-wrap gap-1">
            {template.variables.map((variable) => (
              <Badge key={variable} variant="outline" className="text-xs">
                {`{${variable}}`}
              </Badge>
            ))}
          </div>
        </div>
      </div>
      
      <div className="flex justify-end">
        <Button onClick={onClose}>Fechar</Button>
      </div>
    </div>
  );
};